import { Container, Flex, OldHeading, OldText, Span } from '@gassan-ui'
import { CbQuote } from '@lib/kontent/models/CbQuote'
import { FC } from 'react'

type Props = CbQuote

const Quote: FC<Props> = ({ quote, author, variant }) => {
  const isRegular = variant.value[0].codename === 'regular'
  return (
    <Container
      mb={{ _: '2rem', small: '3rem', large: '5rem' }}
      maxWidth={isRegular && '57rem'}
      bg={isRegular ? 'pampas' : 'shades.50'}
      position="relative"
      p={
        isRegular
          ? { _: '1.5rem', small: '3rem', large: '4rem' }
          : { _: '1rem', small: '2rem 3.5rem ', large: '5rem 9.25rem ' }
      }
    >
      {isRegular ? (
        <OldHeading variant="h4" mb="0" color={'tobaccoBrown'}>
          {quote.value}
        </OldHeading>
      ) : (
        <OldText
          fontFamily="quote"
          fontSize={{ _: '2rem', small: '4rem', large: '5rem' }}
          mb="0"
          textAlign="center"
        >
          {quote.value}
        </OldText>
      )}
      {author && author.value.length > 0 && (
        <Flex
          opacity={isRegular && 0.5}
          alignItems="center"
          mt={{ _: '1rem', small: '1.5rem' }}
          justifyContent={isRegular ? 'flex-start' : 'center'}
        >
          <Span mr="0.5rem" color={isRegular ? 'tobaccoBrown' : 'shades.600'}>
            —
          </Span>
          <OldText variant="small" mb="0" color={isRegular ? 'tobaccoBrown' : 'shades.600'}>
            {author.value}
          </OldText>
        </Flex>
      )}
    </Container>
  )
}

export default Quote
